<nb-form-field>
  <input nbInput
         fullWidth
         [nbDatepicker]="rangepicker"
         [ngModel]="value"
         (ngModelChange)="updateValue($event)"
         [placeholder]="placeholder()"
         readonly>
  <nb-rangepicker #rangepicker></nb-rangepicker>

  @if (value) {
    <button nbSuffix
            nbButton
            ghost
            size="small"
            type="button"
            aria-label="Zeitraum entfernen"
            nbTooltip="Zeitraum entfernen"
            (keydown.enter)="$event.stopPropagation()"
            (click)="updateValue(undefined)">
      <nb-icon icon="close-outline" pack="eva"></nb-icon>
    </button>
  }

  @if (showTodayButton()) {
    <button nbSuffix
            nbButton
            ghost
            size="small"
            type="button"
            aria-label="Heute"
            nbTooltip="Heute"
            (keydown.enter)="$event.stopPropagation()"
            (click)="setRangeFilterToday()">
      <nb-icon icon="calendar-outline" pack="eva"></nb-icon>
    </button>
  }

</nb-form-field>
